import type { EditorState } from 'prosemirror-state';
import type { EditorView } from 'prosemirror-view';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { createProviderToken } from '@core/common-legacy';
import type { MentionElement, MentionElementGroup } from '@core/prosemirror-legacy';
import type { Placeholder } from '@core/wysiwyg-legacy';

export class StateUpdated$ extends Subject<Readonly<EditorState>> {}
export class MentionsStream$ extends Observable<MentionElement[] | MentionElementGroup[]> {}
export const { provide: provideMentionsFooterMessage, inject: injectMentionsFooterMessage } =
  createProviderToken<string>('Mentions footer message')();
export class PlaceholdersStream$ extends Observable<Placeholder[]> {}
export class ScrollStream$ extends Observable<void> {}
export class EditorView$ extends BehaviorSubject<EditorView | null> {}
export interface WysiwygContext {
  owner: { name: string } | null;
}
export class WysiwygContext$ extends BehaviorSubject<WysiwygContext | null> {}
export class ContextTooltipContainerDirectiveToken {
  public container: HTMLElement;
}
